"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RichText_1 = __importDefault(require("@hikakaku/shared/components/estimate/message/RichText"));
exports.default = RichText_1.default;
